import { render, staticRenderFns } from "./Connect.vue?vue&type=template&id=5d864184&lang=pug"
import script from "./Connect.vue?vue&type=script&lang=js"
export * from "./Connect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports